module.exports = __webpack_public_path__ + "img/20220624150843.dfd1c40c.png";